import Hero from "../components/hero";
import ScaleBanner from "../components/scaleBanner";
import Services from "../components/services";
import WhyNodric from "../components/whyNodric";
import HowItWorks from "../components/howItWorks";
import PanelShowcase from "../components/panelShowcase";
import Pricing from "../components/pricing";
import ContactSection from "../components/contactSection";

export default function LandingPage() {
  return (
    <>
      <Hero />
      <ScaleBanner />
      <Services />
      <WhyNodric />
      <HowItWorks />
      <PanelShowcase />
      <Pricing />
      <ContactSection />
    </>
  );
}
